module.exports = __webpack_public_path__ + "static/media/carmel.434274e4.JPG";